<style scoped>  

  @media only screen and (max-width: 360px) {
    .search-input {
      max-width: 80% !important;
    }
  }

  @media only screen and (min-width: 361px) {
    .search-input {
      max-width: 85% !important;
    }
  }

</style>

<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">            
      <div class="six wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui form">
          <div class="field">
            <search-input id="cert-complement-requests-search-input" ref="searchInput" class="search-input" @onSearch="search" />
            <button class="ui icon button m-l-10" @click="$refs.filterModal.show()">
              <i class="filter icon" :class="{ red: !!$store.state.pages.filters.certComplementRequests }"></i>
            </button>
          </div>
        </div>                        
      </div>      
    </div>

    <data-table id="cert-complement-requests-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" 
      sortBy="certId" :asc="false" @onRowClick="onShowRequest" />

    <filter-modal ref="filterModal" @onApply="filter" @onRemove="clearFilter" />

  </div>

</template>

<script>
  
  import FilterModal from "./filter"
  import CertComplementRequestService from "@/services/cert-complement-request-service"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "CertComplementRequestsPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {     
        title: "Solicitações de Complemento de Laudos",   
        service: new CertComplementRequestService(),
        attributes: ["id", "status", "createdAt", "certId"],
        fields: [          
          { prop: "certId", label: "Número do Laudo" },  
          { prop: "status", label: "Status", render: this.renderStatus },
          { prop: "date", label: "Data", render: (request) => this.$formatDate(request.createdAt) },
          { prop: "time", label: "Hora", render: (request) => this.$formatTime(request.createdAt) },
          { prop: "requester.name", model: "User", modelAlias: "requester", label: "Solicitante" },
          { prop: "responsible.name", model: "User", modelAlias: "responsible", label: "Responsável" },                  
        ],
      }
    },

    components: {
      FilterModal,
    },

    methods: {

      onShowRequest(data) {
        this.$router.push(`/procs/certs/${data.row.certId}/show?historyBack=true`)
      },

      renderStatus(request) {

        const statusList = CertComplementRequestService.STATUS

        return `<i class="${statusList[request.status].icon}"></i> ${statusList[request.status].description}`
      },
    },
  }

</script>
